var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.612,
    height: 17.612,
    viewBox: "0 0 17.612 17.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "completed",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38051",
    "data-name": "Path 38051",
    d: "M8.806,0A8.806,8.806,0,1,1,0,8.806,8.806,8.806,0,0,1,8.806,0Z",
    transform: "translate(0 0)",
    fill: "#f84b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M.156.156a.533.533,0,0,1,.754,0L3.731,2.977,6.552.156A.533.533,0,0,1,7.306.91L4.485,3.731,7.306,6.552a.533.533,0,0,1-.754.754L3.731,4.485.91,7.306a.533.533,0,0,1-.754-.754L2.977,3.731.156.91A.533.533,0,0,1,.156.156Z",
    transform: "translate(5.075 5.076)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCompletedIcon);
export default __webpack_public_path__ + "static/media/error-completed-icon.d177db11c397205b608b3a24777d1fdf.svg";
export { ForwardRef as ReactComponent };